import React from 'react';
import PortfolioMasonry from 'views/PortfolioMasonry';

const PortfolioMasonryPage = () => {
  return <PortfolioMasonry />;
};

export default PortfolioMasonryPage;